import requestApi from "../../common/boxp_api_client";

function getDispatchHistory(params) {
    return requestApi({
        url: `/dispatch_history`,
        method: "GET",
        params: params,
    });
}

function getDispatchDetails(params) {
    return requestApi({
        url: `/get_dispatch_files`,
        method: "GET",
        params: params,
    });
}
function uploadDispatchFiles(formData) {
    return requestApi({
        url: `/upload_dispatch_documents`,
        method: "POST",
        data: formData,
    });
}






















const DispatchServices = {
    getDispatchHistory,
    getDispatchDetails,
    uploadDispatchFiles

};

export default DispatchServices;
